<script setup lang="ts">
import { computed, ref } from 'vue'
import type { RecentSearch } from '@/types/searchItemsTypes'
import { useSearchHistoryQuery } from '@/queries/search'
import { useDeleteSearchHistoryMutation } from '@/mutations'

const emit = defineEmits<{
  (e: 'setTextFromSearchHistoryToTextArea', item: RecentSearch): void
}>()

const historyParams = ref({
  size: 3,
  type: 'text'
})

const searchHistoryQuery = useSearchHistoryQuery(historyParams)
const deleteHistoryMutation = useDeleteSearchHistoryMutation()

const searchHistoryItems = computed<RecentSearch[]>(
  () => searchHistoryQuery.data.value?.recent_searches ?? []
)

async function deleteHistoryItem(idOfHistoryItem: string) {
  if (!idOfHistoryItem) return
  await deleteHistoryMutation.mutateAsync([idOfHistoryItem])
  await searchHistoryQuery.refresh(true)
}

async function deleteAllHistoryItems() {
  if (!searchHistoryItems.value.length) return
  const ids = searchHistoryItems.value.map((item) => item.id)
  await deleteHistoryMutation.mutateAsync(ids)
  await searchHistoryQuery.refresh(true)
}
</script>

<template>
  <div v-if="searchHistoryItems.length" class="search-history-inner">
    <div class="history-title__wrapper">
      <span class="history-title title">Search history</span>
      <span class="clear-history-btn" @click.stop="deleteAllHistoryItems"> Clear </span>
    </div>

    <ul class="search-history-text-tip">
      <li
        v-for="item in searchHistoryItems"
        @click="emit('setTextFromSearchHistoryToTextArea',item)"
        class="text-tip body"
      >
        {{ item?.query?.text }}
        <img class="history-image" v-if="item?.query?.image" :src="item?.query?.image" />
        <div>
          <i
            class="pi pi-times"
            @click.stop="deleteHistoryItem(item.id)"
            style="color: rgba(145, 145, 145, 1)"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.history-title__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-history-inner {
  width: 100%;
  padding: 12px 8px;
}

.clear-history-btn {
  font-size: 19px;
  font-weight: 500;
  color: rgba(35, 47, 69, 0.6);
}

.search-history-text-tip {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  list-style: none;
  padding: 0;
}


.text-tip {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:8px 12px;
  cursor: pointer;
}

.text-tip:hover {
  background: var(--black-10);
  border-radius: 28px;
}

.history-image {
  height: 40px;
  border-radius: 8px;
}
</style>